import React from 'react';

const Header = () => (
    <header className="header-bg text-white py-2 mb-3">
        <div className=" d-inline-flex gap-2 align-items-center justify-content-center w-100">
                <img src="O_plus_delivery_transparent.png" className="ml-5" width="100" height="100"
                     alt="My Happy SVG"/>

                <div className="text-center">
                    <h2 className="mb-0 display-5 fw-bold ">Delivery Express</h2>
                    <div className=" fst-italic d-inline-flex gap-2 align-items-center align-content-end end">
                        <p className="lead ps-8 mb-0"> Pourquoi déployer sans style  </p>
                        <img src="rocket.svg" className="ml-5" width='20' alt="My Happy SVG"/>
                        <img src="rocket.svg" className="ml-5" width='20' alt="My Happy SVG"/>
                        <img src="rocket.svg" className="ml-5" width='20' alt="My Happy SVG"/>

                    </div>
                </div>

        </div>
    </header>
);

export default Header;
